import * as en from './en';
import * as tr from './tr';

// eslint-disable-next-line import/no-anonymous-default-export
export default { en, tr };
